import { render, staticRenderFns } from "./VManagersTable.vue?vue&type=template&id=783215a2"
import script from "./VManagersTable.vue?vue&type=script&lang=js"
export * from "./VManagersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports